export default function appendSearchParams(endpoint: string, params: Record<string, string | number>): string {
    const searchParams = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        searchParams.set(key, String(value))
    }

    const separator = endpoint.includes("?") ? "&" : "?"
    return `${endpoint}${separator}${searchParams.toString()}`
}
